import React from 'react'
import { Box, Container, Grid, Stack, Typography, useTheme, useMediaQuery } from '@mui/material'
import {
  BankOutlinedIcon,
  BotOutlinedIcon,
  LibraryOutlinedIcon,
  ListCheckOutlinedIcon,
  ScaleOutlinedIcon,
  SchoolOutlinedIcon,
} from '../../../components/Icons'
import MicIcon from '@mui/icons-material/Mic'
import GavelIcon from '@mui/icons-material/Gavel'
import EditNoteIcon from '@mui/icons-material/EditNote'
import PlaylistAddCheckIcon from '@mui/icons-material/PlaylistAddCheck'
import HistoryIcon from '@mui/icons-material/History'
import CampaignIcon from '@mui/icons-material/Campaign'
const gridData = [
  {
    title: 'Voice Command for Quick Searches',
    icon: <MicIcon />,
    description:
      "Step into the future with our Voice Command feature. Access relevant case acts or judgments effortlessly, without lifting a finger. It's the convenience you ha've always wanted.",
  },
  {
    title: 'Research Acts and Judgements Instantly',
    icon: <GavelIcon />,
    description:
      "Cut down your case research work by 90%. With Lawttorney, simply use the prompt in the hint section or input your query to access detailed case acts and judgments in seconds. It's research, redefined.",
  },
  {
    title: 'Draft Legal Documents with GenAI',
    icon: <EditNoteIcon />,
    description:
      "Transform the way you draft legal documents. From notices to decrees, Lawttorney's GenAI-driven drafting tool allows you to produce a variety of legal formats in 90% less time. Efficiency and ease are now at your fingertips, enabling you to focus on what truly matters.",
  },
  {
    title: 'Verify AI Response',
    icon: <PlaylistAddCheckIcon />,
    description:
      'Enhance Accuracy and Confidence in AI-Generated Drafts. Simply re-enter your prompt to cross-check and validate the response, ensuring consistency, reliability, and precision in every legal document.',
  },
  {
    title: 'Seamless History Storage',
    icon: <HistoryIcon />,
    description:
      'Never lose track of your progress. With Lawttorney, your research history is stored securely, allowing you to pick up exactly where you left off - ensuring continuity and peace of mind..',
  },
  {
    title: 'Prompt Hints',
    icon: <CampaignIcon />,
    description:
      'Enhance Your Legal Drafting with AI-Powered Prompt Hints. Get intelligent prompt suggestions for action judgments, legal formats, notices, and references to the Indian Constitution, ensuring accuracy, efficiency, and compliance in every legal document you create.',
  },
]
const WhyChooseUsSection = () => {
  const { spacing } = useTheme()
  const theme = useTheme()
  const smMatched = useMediaQuery(theme.breakpoints.down('sm'))
  const mdMatched = useMediaQuery(theme.breakpoints.down('md'))

  return (
    <Box component='section' bgcolor='common.white' py={smMatched ? 3 : 7.5}>
      <Container maxWidth={mdMatched ? false : 'xl'}>
        <Box
          sx={{
            display: 'flex',
            alignItems: 'flex-start',
            flexDirection: 'column',
            gap: 4,
            p: smMatched ? spacing(3, 2) : mdMatched ? spacing(4, 3) : spacing(5, 10),
            background:
              'linear-gradient(289.45deg, rgba(255, 206, 14, 0.5) -18.07%, rgba(255, 219, 80, 0.5) 112.4%)',
          }}
        >
          <Box sx={{ width: 1, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
            <Typography variant={smMatched ? 'h3' : 'h1'}>Why Choose Us</Typography>
          </Box>
          <Grid container spacing={smMatched ? 3 : 5}>
            {gridData.map((item, index) => (
              <Grid item xs={12} sm={6} md={4} key={index}>
                <Stack
                  spacing={smMatched ? 2 : 3}
                  sx={{
                    bgcolor: 'common.white',
                    borderRadius: 2,
                    p: smMatched ? spacing(3, 2) : spacing(5, 4),
                    height: 1,
                  }}
                >
                  <Box
                    sx={{
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                    }}
                  >
                    {item.icon}
                    {/* <MicIcon /> */}
                    {/* {React.createElement(item.icon, {
                      sx: { textAlign: 'center', width: 40, height: 40, fill: 'none' },
                    })} */}
                  </Box>

                  <Typography textAlign='center' variant='h4'>
                    {item.title}
                  </Typography>
                  <Typography textAlign='center'>{item.description}</Typography>
                </Stack>
              </Grid>
            ))}
          </Grid>
        </Box>
      </Container>
    </Box>
  )
}

export default WhyChooseUsSection
